import { useImagePaths } from "@bundles/wheels/data/hooks"
import { memo, useEffect } from "react"
import { useDispatch } from "react-redux"
import { createImagePathsRequest } from "../business/helper"
import { Actions } from "../business"

type Props = {
    selectedColor: string
    imageId2D: string
}

export const Image2DPaths = memo((props: Props) => {
    const { selectedColor, imageId2D } = props
    const dispatch = useDispatch()
    const { imgPaths, isLoading } = useImagePaths(createImagePathsRequest(selectedColor || "000000", imageId2D))

    useEffect(() => {
        if (!isLoading && imgPaths) {
            dispatch(Actions.update2DConfigurator(imgPaths?.images, imgPaths?.rimsPosition))
        }
    }, [imgPaths])

    useEffect(() => {
        isLoading && dispatch(Actions.setConfigLoader())
    }, [isLoading])

    return null
})
